module.exports = __webpack_public_path__ + "img/calendar-1.531ad15b.svg";